import CollectionsCategories from "components/collectionsCategories/CollectionsCategories";
import Spinner from "components/spinner/Spinner";
import Tab from "components/tab";
import {
  getCategories,
  selectCategoriesMap,
  selectError,
  selectLoading,
} from "features/categories/categoriesSlice";
import { categoriesArray } from "features/categories/categoriesThunk";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getCategoriesAndDocuments } from "services/firebase";
import "styles/main.scss";
import { Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";
import { fetchCategories } from "utils/categories/categoriesUtils";

// export const SHOP_DATA = [
//   {
//     title: "Hats",
//     items: [
//       {
//         id: 1,
//         name: "Brown Brim",
//         imageUrl: "https://i.ibb.co/ZYW3VTp/brown-brim.png",
//         price: 25,
//       },
//       {
//         id: 2,
//         name: "Blue Beanie",
//         imageUrl: "https://i.ibb.co/ypkgK0X/blue-beanie.png",
//         price: 18,
//       },
//       {
//         id: 3,
//         name: "Brown Cowboy",
//         imageUrl: "https://i.ibb.co/QdJwgmp/brown-cowboy.png",
//         price: 35,
//       },
//       {
//         id: 4,
//         name: "Grey Brim",
//         imageUrl: "https://i.ibb.co/RjBLWxB/grey-brim.png",
//         price: 25,
//       },
//       {
//         id: 5,
//         name: "Green Beanie",
//         imageUrl: "https://i.ibb.co/YTjW3vF/green-beanie.png",
//         price: 18,
//       },
//       {
//         id: 6,
//         name: "Palm Tree Cap",
//         imageUrl: "https://i.ibb.co/rKBDvJX/palm-tree-cap.png",
//         price: 14,
//       },
//       {
//         id: 7,
//         name: "Red Beanie",
//         imageUrl: "https://i.ibb.co/bLB646Z/red-beanie.png",
//         price: 18,
//       },
//       {
//         id: 8,
//         name: "Wolf Cap",
//         imageUrl: "https://i.ibb.co/1f2nWMM/wolf-cap.png",
//         price: 14,
//       },
//       {
//         id: 9,
//         name: "Blue Snapback",
//         imageUrl: "https://i.ibb.co/X2VJP2W/blue-snapback.png",
//         price: 16,
//       },
//     ],
//   },
//   {
//     title: "Sneakers",
//     items: [
//       {
//         id: 10,
//         name: "Adidas NMD",
//         imageUrl: "https://i.ibb.co/0s3pdnc/adidas-nmd.png",
//         price: 220,
//       },
//       {
//         id: 11,
//         name: "Adidas Yeezy",
//         imageUrl: "https://i.ibb.co/dJbG1cT/yeezy.png",
//         price: 280,
//       },
//       {
//         id: 12,
//         name: "Black Converse",
//         imageUrl: "https://i.ibb.co/bPmVXyP/black-converse.png",
//         price: 110,
//       },
//       {
//         id: 13,
//         name: "Nike White AirForce",
//         imageUrl: "https://i.ibb.co/1RcFPk0/white-nike-high-tops.png",
//         price: 160,
//       },
//       {
//         id: 14,
//         name: "Nike Red High Tops",
//         imageUrl: "https://i.ibb.co/QcvzydB/nikes-red.png",
//         price: 160,
//       },
//       {
//         id: 15,
//         name: "Nike Brown High Tops",
//         imageUrl: "https://i.ibb.co/fMTV342/nike-brown.png",
//         price: 160,
//       },
//       {
//         id: 16,
//         name: "Air Jordan Limited",
//         imageUrl: "https://i.ibb.co/w4k6Ws9/nike-funky.png",
//         price: 190,
//       },
//       {
//         id: 17,
//         name: "Timberlands",
//         imageUrl: "https://i.ibb.co/Mhh6wBg/timberlands.png",
//         price: 200,
//       },
//     ],
//   },
//   {
//     title: "Jackets",
//     items: [
//       {
//         id: 18,
//         name: "Black Jean Shearling",
//         imageUrl: "https://i.ibb.co/XzcwL5s/black-shearling.png",
//         price: 125,
//       },
//       {
//         id: 19,
//         name: "Blue Jean Jacket",
//         imageUrl: "https://i.ibb.co/mJS6vz0/blue-jean-jacket.png",
//         price: 90,
//       },
//       {
//         id: 20,
//         name: "Grey Jean Jacket",
//         imageUrl: "https://i.ibb.co/N71k1ML/grey-jean-jacket.png",
//         price: 90,
//       },
//       {
//         id: 21,
//         name: "Brown Shearling",
//         imageUrl: "https://i.ibb.co/s96FpdP/brown-shearling.png",
//         price: 165,
//       },
//       {
//         id: 22,
//         name: "Tan Trench",
//         imageUrl: "https://i.ibb.co/M6hHc3F/brown-trench.png",
//         price: 185,
//       },
//     ],
//   },
//   {
//     title: "Womens",
//     items: [
//       {
//         id: 23,
//         name: "Blue Tanktop",
//         imageUrl: "https://i.ibb.co/7CQVJNm/blue-tank.png",
//         price: 25,
//       },
//       {
//         id: 24,
//         name: "Floral Blouse",
//         imageUrl: "https://i.ibb.co/4W2DGKm/floral-blouse.png",
//         price: 20,
//       },
//       {
//         id: 25,
//         name: "Floral Dress",
//         imageUrl: "https://i.ibb.co/KV18Ysr/floral-skirt.png",
//         price: 80,
//       },
//       {
//         id: 26,
//         name: "Red Dots Dress",
//         imageUrl: "https://i.ibb.co/N3BN1bh/red-polka-dot-dress.png",
//         price: 80,
//       },
//       {
//         id: 27,
//         name: "Striped Sweater",
//         imageUrl: "https://i.ibb.co/KmSkMbH/striped-sweater.png",
//         price: 45,
//       },
//       {
//         id: 28,
//         name: "Yellow Track Suit",
//         imageUrl: "https://i.ibb.co/v1cvwNf/yellow-track-suit.png",
//         price: 135,
//       },
//       {
//         id: 29,
//         name: "White Blouse",
//         imageUrl: "https://i.ibb.co/qBcrsJg/white-vest.png",
//         price: 20,
//       },
//     ],
//   },
//   {
//     title: "Mens",
//     items: [
//       {
//         id: 30,
//         name: "Camo Down Vest",
//         imageUrl: "https://i.ibb.co/xJS0T3Y/camo-vest.png",
//         price: 325,
//       },
//       {
//         id: 31,
//         name: "Floral T-shirt",
//         imageUrl: "https://i.ibb.co/qMQ75QZ/floral-shirt.png",
//         price: 20,
//       },
//       {
//         id: 32,
//         name: "Black & White Longsleeve",
//         imageUrl: "https://i.ibb.co/55z32tw/long-sleeve.png",
//         price: 25,
//       },
//       {
//         id: 33,
//         name: "Pink T-shirt",
//         imageUrl: "https://i.ibb.co/RvwnBL8/pink-shirt.png",
//         price: 25,
//       },
//       {
//         id: 34,
//         name: "Jean Long Sleeve",
//         imageUrl: "https://i.ibb.co/VpW4x5t/roll-up-jean-shirt.png",
//         price: 40,
//       },
//       {
//         id: 35,
//         name: "Burgundy T-shirt",
//         imageUrl: "https://i.ibb.co/mh3VM1f/polka-dot-shirt.png",
//         price: 25,
//       },
//     ],
//   },
// ];
export default function Shop() {
  useEffect(() => (document.title = "Shop | MariTiny"), []);

  const SHOP_DATA = useSelector(selectCategoriesMap);
  const isLoading = useSelector(selectLoading);
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  useEffect(() => {
    dispatch(categoriesArray());
    // dispatch(fetchCategories());
    // const getCategoriesMap = async () => {
    //   const categoriesArray = await getCategoriesAndDocuments();
    //   dispatch(getCategories(categoriesArray));
    // };
    // getCategoriesMap();
  }, []);

  const data = (keys) => {
    const categoryData = SHOP_DATA[keys];
    if (Array.isArray(keys)) {
      return categoryData;
    }
    return Object.values(categoryData)?.flat();
  };

  return isLoading ? (
    <Spinner />
  ) : error ? (
    <h1 className="text-5xl font-bold text-center">{error.message}</h1>
  ) : (
    Object.keys(SHOP_DATA).map((keys) => (
      <div
        key={keys}
        className="flex flex-col items-center mb-6 xl:px-10 md:px-10"
      >
        <Link to={`/shop/${keys}`}>
          <h2 className="font-bold text-6xl tracking-widest mb-6">
            {keys.toUpperCase()}
          </h2>
        </Link>
        <div className="grid 2xs:w-11/12 xs:w-11/12 sm:w-11/12 md:w-full lg:w-full xl:w-full 2xl:w-full grid-cols-1 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 gap-x-5">
          {data(keys)
            .filter((items, idx) => idx < 4)
            .map((items) => (
              <div key={items.id}>
                <CollectionsCategories
                  key={items.id}
                  items={items}
                  category={keys}
                />
              </div>
            ))}
        </div>
      </div>
    ))
  );
}
